import Axhelper from '@/lib/Axhelper'

class TypyPlacowekService {
	constructor() {
		this.baseUrl = window.RUNTIME_CONFIG.API_URL
		this.endpoints = {
			typyPlacowekAll: '/api/typy_placowek/filters',
			typyPlacowekDetails: '/api/typy_placowek/details',
			typyPlacowekSearch: '/api/typy_placowek/filters',
			typyPlacowekCreate: '/api/typy_placowek',
			typyPlacowekUpdate: '/api/typy_placowek',
			typyPlacowekDelete: '/api/typy_placowek',
		}
	}

	async getAll(options = {}) {
		try {
			const {
				limit = 50,
				sortColumn = '_id',
				sortDirection = 'desc',
			} = options

			const params = new URLSearchParams({
				sortcol: sortColumn,
				sortdir: sortDirection,
				limit: String(limit),
			})
			const url = `${this.endpoints.typyPlacowekAll}?${params.toString()}`
			const response = await Axhelper.sendGetAsync(url)

			if (response.error) {
				return {
					data: [],
					error: response.error,
					totalCount: 0,
					hasMore: false,
				}
			}

			const totalCount = response.headers?.['x-total-count']
				? parseInt(response.headers['x-total-count'], 10)
				: response.data?.length || 0

			return {
				data: response.data || [],
				error: null,
				totalCount,
				hasMore: (response.data?.length || 0) < totalCount,
				headers: response.headers,
			}
		} catch (error) {
			console.error('TypyPlacowekService.getAll error:', error)
			return {
				data: [],
				error: error.message || 'Failed to fetch typy placowek',
				totalCount: 0,
				hasMore: false,
			}
		}
	}

	async getById(typyPlacowekId) {
		try {
			if (!typyPlacowekId) {
				return {
					data: null,
					error: 'Invalid typy placowek ID provided',
				}
			}

			const url = `${this.endpoints.typyPlacowekDetails}/${encodeURIComponent(typyPlacowekId)}`
			const response = await Axhelper.sendGetAsync(url)

			if (response.error) {
				return {
					data: null,
					error: response.error,
				}
			}

			return {
				data: response.data || null,
				error: null,
			}
		} catch (error) {
			console.error('TypyPlacowekService.getById error:', error)
			return {
				data: null,
				error: error.message || 'Failed to fetch typy placowek details',
			}
		}
	}

	async search(searchTerm, options = {}) {
		try {
			if (!searchTerm) {
				return {
					data: [],
					error: 'Invalid search term provided',
					totalCount: 0,
					hasMore: false,
				}
			}

			const {
				limit = 50,
				sortColumn = '_id',
				sortDirection = 'desc',
			} = options

			const params = new URLSearchParams({
				sortcol: sortColumn,
				sortdir: sortDirection,
				limit: String(limit),
			})
			const url = `${this.endpoints.typyPlacowekSearch}?searchText=${encodeURIComponent(searchTerm)}&${params.toString()}`
			const response = await Axhelper.sendGetAsync(url)

			if (response.error) {
				return {
					data: [],
					error: response.error,
					totalCount: 0,
					hasMore: false,
				}
			}

			const totalCount = response.headers?.['x-total-count']
				? parseInt(response.headers['x-total-count'], 10)
				: response.data?.length || 0

			return {
				data: response.data || [],
				error: null,
				totalCount,
				hasMore: (response.data?.length || 0) < totalCount,
				headers: response.headers,
			}
		} catch (error) {
			console.error('TypyPlacowekService.search error:', error)
			return {
				data: [],
				error: error.message || 'Failed to search typy placowek',
				totalCount: 0,
				hasMore: false,
			}
		}
	}

	async create(typyPlacowekData) {
		try {
			const response = await Axhelper.sendPostAsync(this.endpoints.typyPlacowekCreate, typyPlacowekData)

			if (response.error) {
				return {
					success: false,
					error: response.error,
				}
			}

			return {
				success: true,
				error: null,
				data: response.data || null,
			}
		} catch (error) {
			console.error('TypyPlacowekService.create error:', error)
			return {
				success: false,
				error: error.message || 'Failed to create typy placowek',
			}
		}
	}

	async update(typyPlacowekId, typyPlacowekData) {
		try {
			if (!typyPlacowekId) {
				return {
					success: false,
					error: 'Invalid typy placowek ID provided',
				}
			}

			const url = `${this.endpoints.typyPlacowekUpdate}/${encodeURIComponent(typyPlacowekId)}`
			const response = await Axhelper.sendPutAsync(url, typyPlacowekData)

			if (response.error) {
				return {
					success: false,
					error: response.error,
				}
			}

			return {
				success: true,
				error: null,
				data: response.data || null,
			}
		} catch (error) {
			console.error('TypyPlacowekService.update error:', error)
			return {
				success: false,
				error: error.message || 'Failed to update typy placowek',
			}
		}
	}

	async delete(typyPlacowekId) {
		try {
			if (!typyPlacowekId) {
				return {
					success: false,
					error: 'Invalid typy placowek ID provided',
					message: null,
				}
			}

			const url = `${this.endpoints.typyPlacowekDelete}/${encodeURIComponent(typyPlacowekId)}`
			const response = await Axhelper.sendDeleteAsync(url)

			if (response.error) {
				return {
					success: false,
					error: response.error,
					message: null,
				}
			}

			return {
				success: true,
				error: null,
				message: response.data || 'Typy placowek record deleted successfully',
			}
		} catch (error) {
			console.error('TypyPlacowekService.delete error:', error)
			return {
				success: false,
				error: error.message || 'Failed to delete typy placowek',
				message: null,
			}
		}
	}
}

export default new TypyPlacowekService()
